
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apps",
      function () {
        return require("private-next-pages/apps.tsx");
      }
    ]);
  